import React, { useEffect, useState } from 'react';

// 스티키 앵커 내비 (목업 `.anav`).
//   헤더(StickyHeader) 아래에 붙는 칩 내비. 각 앵커 id 로 부드럽게 스크롤하고,
//   IntersectionObserver 로 현재 섹션을 강조한다(스크롤스파이).
export interface AnchorItem {
  id: string;
  label: string;
}

export const StickyAnchorNav: React.FC<{ items: AnchorItem[] }> = ({ items }) => {
  const [active, setActive] = useState<string | undefined>(items[0]?.id);

  useEffect(() => {
    if (typeof window === 'undefined' || items.length === 0) return;
    const els = items
      .map((it) => document.getElementById(it.id))
      .filter((el): el is HTMLElement => el != null);
    if (els.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible[0]) setActive(visible[0].target.id);
      },
      { rootMargin: '-100px 0px -70% 0px', threshold: 0 },
    );
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [items]);

  const handleClick = (e: React.MouseEvent, id: string) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setActive(id);
    }
  };

  if (items.length <= 1) return null;

  return (
    <nav className="sticky top-[46px] z-10 flex gap-1 overflow-x-auto border-b border-ca-line bg-frame px-2 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
      {items.map((it) => (
        <a
          key={it.id}
          href={`#${it.id}`}
          onClick={(e) => handleClick(e, it.id)}
          className={`relative flex-shrink-0 whitespace-nowrap px-2.5 py-3 text-[13px] font-bold transition-colors ${
            active === it.id
              ? 'text-ink after:absolute after:inset-x-2.5 after:-bottom-px after:h-[2.5px] after:rounded after:bg-accent after:content-[""]'
              : 'text-muted'
          }`}
        >
          {it.label}
        </a>
      ))}
    </nav>
  );
};

export default StickyAnchorNav;
